import React from 'react';
import PropTypes from 'prop-types';

export const StepTitle = ({ show, title, handleLinkClick }) => {
  if (!show) return title;

  return <a onClick={handleLinkClick}>{title}</a>;
};

StepTitle.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string.isRequired,
  handleLinkClick: PropTypes.func.isRequired
};

export default StepTitle;



// WEBPACK FOOTER //
// ./src/components/Stepper/StepTitle.js